export const MeasurementUnit = {
  PIECES: 0,
  METERS: 1
};

export const MeasurementUnitText = {
  [MeasurementUnit.PIECES]: 'Pieces',
  [MeasurementUnit.METERS]: 'Meters'
};
